import { useAssociationDefinitions } from 'automation-ui-associations/hooks/associationDefinitionsHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const wireAssociationDefinitions = WrappedComponent => props => {
  const query = useAssociationDefinitions(props.fromObjectTypeIds);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    associationDefinitionsQuery: query
  }));
};
export default wireAssociationDefinitions;